<template>
  <div>
    <div class="rule-common">
      <p>1.佣金到账时间：</p>
      <p>用户确认收货订单完成24小时后到账</p>
    </div>
    <div class="rule-common">
      <p>2.获得佣金金额计算方式：</p>
      <p>商品佣金=商品建议零售价*购买数量*佣金比例(2%-20%不等)订单佣金=订单内所有商品佣金总和</p>
    </div>
    <div class="rule-common">
      <p>3.若发生退款：</p>
      <p>发生退款的商品，商家同意退款后，店长无法获得该商品的佣金</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.rule-common {
  margin: 20px 15px 0;
  font-size: 15px;
  &:first-child {
    margin-top: 10px;
  }
  p:first-child {
    font-size: 17px;
    font-weight: 800;
  }
  p:last-child {
    margin-top: 5px;
  }
}
</style>